import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useIntl } from 'react-intl';

import { PATH } from 'src/features/navigation/utils/constants';
import { ActiveStay, PastStay, STAY_TYPE } from 'src/features/stay/types';
import { visitorTypeBadgeOptions } from 'src/features/gatewayPass/utils/constants';
import { visitorMessages } from 'src/features/visitor/utils/messages';
import { Badge } from 'src/registry/ui/Badge';
import { ICON_MAP } from 'src/utils/constants';
import useHasPermissions from 'src/hooks/useHasPermissions';
import { PERMISSION } from 'src/features/auth';
import { LinkWithIcon } from 'src/registry/components/navigation/LinkWithIcon';

type VisitorDataFieldProps = {
    stayData: ActiveStay | PastStay;
    stayType: STAY_TYPE;
};

const VisitorDataField = ({ stayData, stayType }: VisitorDataFieldProps) => {
    const { formatMessage } = useIntl();

    const visitor = stayData?.main_identifier.value ?? '-';
    const visitorType = stayData?.visitor.type;
    const visitorTypeDisplay = visitorType
        ? `(${formatMessage(visitorTypeBadgeOptions[visitorType].label).toLowerCase()})`
        : '';
    const owner = stayData?.visitor.owner?.name;
    const ownerDisplayValue = owner ? `- ${owner}` : '';

    const permissionAccessVisitors = useHasPermissions([PERMISSION.ACCESS_VISITORS]);

    const visitorData = `${visitor} ${visitorTypeDisplay} ${ownerDisplayValue}`;
    const badgeTheme = stayType === STAY_TYPE.ACTIVE ? 'green' : 'red';
    const badgeText = stayType === STAY_TYPE.ACTIVE ? visitorMessages.active : visitorMessages.past;
    return (
        <div className="flex flex-row flex-wrap gap-2">
            <LinkWithIcon
                to={`/${PATH.VISITORS}/visitor/${stayData?.visitor.id}`}
                linkTitle={visitorData}
                hasPermissions={permissionAccessVisitors}
            />
            <Badge theme={badgeTheme}>
                <FontAwesomeIcon icon={ICON_MAP.WAVE_PULSE} />
                {formatMessage(badgeText)}
            </Badge>
        </div>
    );
};

export default VisitorDataField;
